import { AxiosResponse } from 'axios';
import { SET_YURTZEITEN_TEMPLATES, SET_YURTZEITEN_TEMPLATE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_YURTZEITEN_TEMPLATE_ISLOADING,
  DELETE_YURTZEITEN_TEMPLATE,
  EDIT_YURTZEITEN_TEMPLATE,
  GET_YURTZEITEN_TEMPLATE,
  GET_YURTZEITEN_TEMPLATES,
  REGISTER_YURTZEITEN_TEMPLATE,
  TOGGLE_YURTZEITEN_TEMPLATE_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import YurtzeitenTemplate from '@/services/yurtzeiten_template';
import { Module } from 'vuex';
import { EditYurtzeitenTemplate, RegisterYurtzeitenTemplate, GetYurtzeitenTemplate } from '@/dtos/yurtzeiten_template.dto';

const yurtzeitenTemplate: Module<any, {}> = {
  state: {
    yurtzeitenTemplate: {
      data: null,
      isLoading: false,
    },
    yurtzeitenTemplates: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    yurtzeitenTemplate: (state: { yurtzeitenTemplate: any }) => state.yurtzeitenTemplate,
    yurtzeitenTemplates: (state: { yurtzeitenTemplates: any }) => state.yurtzeitenTemplates,
  },
  mutations: {
    [SET_YURTZEITEN_TEMPLATE]: (
      state: { yurtzeitenTemplate: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitenTemplate.data = payload.data) : null,
        (state.yurtzeitenTemplate.isLoading = payload.isLoading);
    },
    [SET_YURTZEITEN_TEMPLATES]: (
      state: { yurtzeitenTemplates: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitenTemplates.data = payload.data) : null,
        (state.yurtzeitenTemplates.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_YURTZEITEN_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenTemplate.registerYurtzeitenTemplate(
        payload as RegisterYurtzeitenTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITEN_TEMPLATES]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_TEMPLATES, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenTemplate.getYurtzeitenTemplates(
        payload as GetYurtzeitenTemplate
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN_TEMPLATES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_TEMPLATES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_TEMPLATES, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITEN_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenTemplate.getYurtzeitenTemplates(
        payload as GetYurtzeitenTemplate
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN_TEMPLATE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [EDIT_YURTZEITEN_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenTemplate.editYurtzeitenTemplate(
        payload as EditYurtzeitenTemplate
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_YURTZEITEN_TEMPLATE_IS_ACTIVE]: async ({ commit, state }: any, payload: EditYurtzeitenTemplate) => {
      commit(SET_YURTZEITEN_TEMPLATE, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await YurtzeitenTemplate.toggleYurtzeitenTemplateIsActive(
        payload
      );

      if (result) {
        if (result.data.status) {
          let index;
          if (state.yurtzeitenTemplates.data) {
            state.yurtzeitenTemplates.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null)
              state.yurtzeitenTemplates.data[index].isActive = result.data.data.isActive;
          }
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [DELETE_YURTZEITEN_TEMPLATE]: async ({ commit }: any, payload: string) => {
      commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await YurtzeitenTemplate.deleteYurtzeitenTemplate(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_YURTZEITEN_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_YURTZEITEN_TEMPLATE_ISLOADING]: ({ commit }) => {
      commit(SET_YURTZEITEN_TEMPLATE, { isLoading: false });
      commit(SET_YURTZEITEN_TEMPLATES, { isLoading: false });
    },
  },
};

export default yurtzeitenTemplate;

